import { tv } from '~/utils/tv'

export const inputTextHelperTextVariants = tv({
  base: 'justify-star flex w-[100%] flex-wrap items-center gap-onepulse px-onepulse text-left font-rdmodern font-semibold text-text-neutral-alternative text-threepulse',
  variants: {
    hasError: {
      true: 'text-text-danger-alternative',
      false: '',
    },
    readOnly: {
      true: 'cursor-not-allowed',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
      false: '',
    },
  },
  compoundVariants: [
    {
      readOnly: true,
      disabled: false,
      class: 'text-text-neutral-readonly',
    },
  ],
  defaultVariants: {
    error: false,
    disabled: false,
    readOnly: false,
  },
})
